"use client";

import Image from "next/image";
import { useRef } from "react";
import { Images } from "@/assests";
import { usePrefersLight } from "@/hooks/use-color-scheme";
import { G2_URL, TRUSTPILOT_URL } from "@/lib/constants";
import { useTrustpilotLazyLoad } from "./trustpilot-widget";

export default function ReviewBadges() {
  const widgetRef = useRef<HTMLDivElement>(null);
  const prefersLight = usePrefersLight();
  useTrustpilotLazyLoad(widgetRef, prefersLight);

  return (
    <>
      <a
        href={G2_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex h-6 items-center transition-opacity hover:opacity-80"
        aria-label="G2 — 4.7 stars"
      >
        <Image
          src={Images.g2Dark}
          alt="G2 — 4.7 stars"
          width={156}
          height={18}
          className="light:hidden block"
        />
        <Image src={Images.g2Light} alt="" width={156} height={18} className="light:block hidden" />
      </a>

      <div className="inline-flex h-6 items-center">
        <div
          key={prefersLight ? "light" : "dark"}
          ref={widgetRef}
          className="trustpilot-widget"
          data-locale="en-US"
          data-template-id="5419b637fa0340045cd0c936"
          data-businessunit-id="626d5b5575edfb812c69a5e0"
          data-style-height="24px"
          data-style-width="100%"
          data-theme={prefersLight ? "light" : "dark"}
          data-token="4cd644bd-4f99-4b8d-b994-968348c3bc0b"
          style={{ width: 260, height: 24 }}
        >
          <a
            href={TRUSTPILOT_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-muted-foreground text-xs transition-opacity hover:opacity-80"
          >
            Trustpilot
          </a>
        </div>
      </div>
    </>
  );
}
